import { AdContainerSize, ButtonLink, Flex, IntrinsicProps, Title, createComponent, toClassName } from 'react-commons';

import style from './index.module.scss';
import { CaptureClickEvent, CaptureClickEventContext } from '@/lib/util/captureClickEvent';
import { useContext } from 'react';
import Link from 'next/link';

export interface AdFallbackProps extends IntrinsicProps {
  size: AdContainerSize
}

const adContainerClassStates = [
  'banner',
  'mobileBanner',
  'halfPage',
  'inlineRect',
  'largeLeaderboard',
  'largeRect',
  'leaderboard',
  'mediumRect',
  'mobileLeaderboard',
  'skyscraper',
  'smallSquare',
  'square',
  'wideSkyscraper'
];

export default createComponent('AdFallback', { style }, ({ className, mergeClassNames }, props: AdFallbackProps) => {
  className = mergeClassNames(toClassName(className, adContainerClassStates, { [ props.size ]: true }));

  const captureClickEventCtx = useContext(CaptureClickEventContext);

  return (
    <Flex alignCenter justifyCenter className={className} style={props.style}>
      <Flex alignCenter directionColumn>
        <Title className='--textCenter'>Ads keep Shockwave free to play.</Title>
        <p className='--textCenter'>They support our efforts to create content and improve the site. You can also support us with a Shockwave Unlimited Subscription.</p>
        <img src='/images/adFallbackBg.png' alt='Ad Fallback Background' aria-hidden />
        <CaptureClickEvent
          action='upsell'
          location='hero_upsell'
          properties={() => ({
            tag_name: 'upsell_adblock_nag',
            title: captureClickEventCtx.settings.gameTitle ?? '',
            id: captureClickEventCtx.settings.gameId ?? '',
          })}
          href='/unlimited'
        >
          <ButtonLink 
            large secondary rounded 
            href='/unlimited' 
            className='upsell_adblock_nag'
          >
            Subscribe
          </ButtonLink>
        </CaptureClickEvent>
      </Flex>
    </Flex>
  );
});
